// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__7ReCE","footer":"ModalInfo_footer__zAN3e"};